import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"

const Row = ({ blok }) => (
  <SbEditable content={blok}>
    <div
      className={`table__row card card--pd-sm ${
        blok.totals ? " table__row--totals" : ""
      }`}
    >
      <p className="table__heading">{blok.heading}</p>
      <div className="table__group">
        {blok.table_value &&
          blok.table_value.map(
            content =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
          )}
      </div>
    </div>
  </SbEditable>
)

Row.propTypes = {
  blok: PropTypes.shape({
    totals: PropTypes.bool,
    heading: PropTypes.string,
    table_value: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default Row
